var errors = {
  NOT_FOUND: new Error('Key was not found in capsule'),
  SERVER_ERROR: new Error('Failed to perform operarion on server'),
  LOCAL_STORAGE_UNSUPPORTED: new Error('LocalStorage is not supported'),
  COOKIE_CONSENT_DISALLOWED: new Error('The item cannot be set because the user has not approved the category it belongs to')
};
export function toError(str) {
  return Object.keys(errors).map(function (key) {
    return errors[key];
  }).find(function (err) {
    return err.message === str;
  }) || new Error(str);
}
export var PREFIX_SEPARATOR = '|';
export var KEY_SEPARATOR = '#';
export var STORAGE_PREFIX = 'capsule';
export var NOT_FOUND = errors.NOT_FOUND;
export var CONNECTION_MAX_TIMEOUT = 2000;
export var MESSAGE_MAX_TIMEOUT = 8000;
export var SERVER_ERROR = errors.SERVER_ERROR;
export var LOCAL_STORAGE_UNSUPPORTED = errors.LOCAL_STORAGE_UNSUPPORTED;
export var COOKIE_CONSENT_DISALLOWED = errors.COOKIE_CONSENT_DISALLOWED;